import { Button } from 'ui/button/button.module';
import { Modal } from 'ui/modal/modal.module';

import { pauseAllMedia } from 'components/mediaControls/helpers';
import { BUTTON_SIZE, BUTTON_TYPE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import {
	addClass,
	animation,
	readFromLs,
	removeClass,
	removeScaleZoomRestriction,
	removeStartConvo,
	setCustomTagHTML,
	stopCurrentFlowandSendMsg,
	writeToLs,
} from 'helpers/helpers';
import { emitAskUserIdEvent, emitInitMsgEvent, updateChatEvent } from 'helpers/socket';
import { ENGT_CHAT } from 'js/bot.model';
import { appendStatusDivider } from 'js/conversation';

import { headerOptions } from './headerOptions.model';
import { HeaderOptionsTemplate } from './headerOptions.template';

const modalWrapperId = 'exitChatModal';
const modalContentId = 'exitChatModalContent';

let closeChatModal;
export class HeaderOptions {
	allInstances = [];

	constructor(props) {
		HeaderOptions.allInstances.push(this);

		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEvents();
		this.initHelpers();
	}

	initData(props) {
		this.data = { ...headerOptions };

		this.setter({
			...props,
			closeModal: {
				wid: modalWrapperId,
				cid: modalContentId,
			},
			livechat: readFromLs(LS().LIVECHAT) === 'true',
		});
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.id = `engtHeaderOptions${this.data.type}`;
		wrapper.className = 'engt-header-options';
		wrapper.innerHTML = HeaderOptionsTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const { exitHeader, close, closeModal, livechat } = this.data;
		const ref = this;

		if (!closeChatModal) {
			const closeButton = new Button({
				type: livechat ? BUTTON_TYPE.SECONDARY : BUTTON_TYPE.PRIMARY,
				label: ENGT_CHAT.get('GENERIC_STRINGS')?.CLOSE_CHAT || close,
				id: 'engtHeaderCloseBtn',
				size: BUTTON_SIZE.MEDIUM,
				onClick() {
					ENGT_CHAT.get('onMinimize')();
					ref.closeChatModal.close('', true);
				},
				radius: 18,
			});

			const modalPrimaryButton = closeButton.render();
			const modalContent = document.createElement('div');
			modalContent.className = 'engt-header-modal-body';
			modalContent.innerHTML = `<span id="engtHeaderBody" style="text-align: center;margin-bottom: 16px;">${
				ENGT_CHAT.get('GENERIC_STRINGS')?.CLOSE_CHAT_PROMPT || exitHeader
			}</span>`;
			modalContent.appendChild(document.createElement('exit-live-chat-btn'));
			modalContent.appendChild(modalPrimaryButton);

			this.closeChatModal = new Modal({
				wrapperId: closeModal.wid,
				contentId: closeModal.cid,
				content: modalContent,
			});
			setTimeout(() => {
				setCustomTagHTML(document.querySelector('close-chat-modal'), this.closeChatModal.render());
			}, 1000);
		}
	}

	onChatClose() {
		const { closeModal, exitConversation } = this.data;
		const isLiveChatOngoing = readFromLs(LS().LIVECHAT) === 'true';
		const modalContent = document.querySelector(`#${closeModal.cid} > .engt-header-modal-body`);
		const isExitLcBtnExists = document.querySelector(`#${closeModal.cid} > #exitLiveChatBtn`);

		if (!isLiveChatOngoing) {
			ENGT_CHAT.get('onMinimize')();
			if (isExitLcBtnExists) {
				setCustomTagHTML(isExitLcBtnExists, document.createElement('exit-live-chat-btn'));
			}
		} else {
			if (modalContent && !isExitLcBtnExists) {
				const exitConvButton = new Button({
					type: BUTTON_TYPE.PRIMARY,
					label: ENGT_CHAT.get('GENERIC_STRINGS')?.EXIT_AGENT_CONVERSATION || exitConversation,
					size: BUTTON_SIZE.MEDIUM,
					onClick: this.onExitLiveChat,
					radius: 18,
					id: 'exitLiveChatBtn',
				}).render();

				setCustomTagHTML(modalContent.querySelector('exit-live-chat-btn'), exitConvButton);
			}
			this.closeChatModal.open();
		}
	}

	initEvents() {
		const ref = this;

		this.html.querySelector('#engtClose').addEventListener('click', ref.onChatClose.bind(this));

		ENGT_CHAT.set('startNewConversation', (sendQueryMsg = '', config = {}) => {
			updateChatEvent(true);

			removeStartConvo();
			ENGT_CHAT.set('isAllInputsDisabled', false);
			writeToLs(
				LS().TAB_MESSAGES,
				JSON.stringify({ action: 'disable_session_timeout', tabId: ENGT_CHAT.get('socketId') })
			);

			if (readFromLs(LS().LIVECHAT) === 'true') {
				ENGT_CHAT.get('showUploadBtn')?.();
			} else if (sendQueryMsg && typeof sendQueryMsg === 'string') {
				if (readFromLs(LS().GOT_UID) === 'true') {
					stopCurrentFlowandSendMsg(sendQueryMsg, config);
				} else {
					emitAskUserIdEvent();
				}
			} else {
				const launchScreen = ENGT_CHAT.get('config.isLaunchScreenEnabled') || undefined;

				// trigger welcome new user path
				ENGT_CHAT.set('config.sessionExpired', true);
				emitAskUserIdEvent();
				const triggerConfig = ENGT_CHAT.get('triggerButtonConfig');
				if (launchScreen || triggerConfig.isFlowTriggeredFromTriggers) {
					emitInitMsgEvent();
				}

				ENGT_CHAT.set('firstTime', true);
				ENGT_CHAT.set('config.launch_flow', ENGT_CHAT.get('config.launch_flow_copy'));
				if (ENGT_CHAT.get('config.welcomeMessageCopy')) {
					ENGT_CHAT.set('config.welcome_msg', ENGT_CHAT.get('config.welcomeMessageCopy'));
				}
			}
		});

		ENGT_CHAT.set('onMinimize', () => {
			const popUp = document.getElementById('engt-popup');
			const launchIcon = document.getElementById('engtLauncherIcon');
			ENGT_CHAT.get('hideChatSettingsScreen')();
			ENGT_CHAT.set('config.isChatOpened', false);
			ENGT_CHAT.get('menuClose')();
			removeScaleZoomRestriction();
			animation.messagesOut();
			animation.launchScreenOut();
			pauseAllMedia();
			addClass(popUp, 'engt-popup-hidden');
			removeClass(document.getElementById('engtWrapper'), 'engt-wrapper-open');
			addClass(launchIcon, 'engt-launcher-icon-animate');
			launchIcon.setAttribute('tabindex', 0);
			setTimeout(() => {
				removeClass(popUp, 'engt-launch-screen-open');
				removeClass(popUp, 'engt-chat-screen-open');
				removeClass(launchIcon, 'engt-launcher-icon-hidden');
				addClass(popUp, 'engt-popup-hidden-size');
			}, 400);
		});
	}

	initHelpers() {
		ENGT_CHAT.set('reRenderHeaderOptions', this.reRender.bind(this));
		ENGT_CHAT.set('onEndChat', this.onEndChat.bind(this));
	}

	onEndChat = () => {
		updateChatEvent(false);
		if (!ENGT_CHAT.get('startConvoAdded')) {
			appendStatusDivider();
			const closeChatDivider = Array.from(document.querySelectorAll('.engt-status-divider-wrapper')).pop();
			closeChatDivider?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
		}
		ENGT_CHAT.set('startConvoAdded', true);
		ENGT_CHAT.get('renderStartConversation')();
		ENGT_CHAT.get('menuClose')();
		ENGT_CHAT.get('onMinimize')();
		ENGT_CHAT.set('triggerSessionExpired', true);
		writeToLs(LS().GOT_UID, 'false');
	};

	onExitLiveChat = () => {
		this.closeChatModal.close('', true);
		ENGT_CHAT.get('hideUploadBtn')?.();
		ENGT_CHAT.get('sendMessage')('Exit Conversation', {
			message: {
				postback: 'live_chat_action=exit_live_chat',
				text: 'Exit Conversation',
				type: 'postback',
			},
		});
		if (ENGT_CHAT.get('config.showReplyArea') === false) {
			ENGT_CHAT.get('hideInputBox')();
		}
		writeToLs(LS().LIVECHAT, false);
		this.reRender();
	};

	reRender() {
		HeaderOptions.allInstances.forEach((instance) => {
			instance.initData({ type: instance.data.type });
			instance.initWrapper();
			instance.initComponents();
			instance.initEvents();
			document
				.getElementById(`engtHeaderOptions${instance.data.type}`)
				?.parentNode?.replaceChild?.(
					instance.html,
					document.getElementById(`engtHeaderOptions${instance.data.type}`)
				);
		});
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}

HeaderOptions.allInstances = [];
